import { render, staticRenderFns } from "./PokemonDetails.vue?vue&type=template&id=5c9a4de9&scoped=true"
import script from "./PokemonDetails.vue?vue&type=script&lang=js"
export * from "./PokemonDetails.vue?vue&type=script&lang=js"
import style0 from "./PokemonDetails.vue?vue&type=style&index=0&id=5c9a4de9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9a4de9",
  null
  
)

export default component.exports